import { ConcreteEncodable } from "./ConcreteEncodable";

import { PrivilegeGroupImplEncoder } from "../../encoder/PrivilegeGroupImplEncoder";

import * as CubiqTS from "../../index";
import { PrivilegeGroup } from "../PrivilegeGroup";

export class PrivilegeGroupImpl extends ConcreteEncodable implements PrivilegeGroup {
  public static enType: string = "com.bcdfx.model.PrivilegeGroupImpl";

  /*FID=1*/
  public roles: Array<string> | null = null;
  /*FID=2*/
  public members: Array<string> | null = null;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = PrivilegeGroupImplEncoder.Instance;
    this.setEncodableType(PrivilegeGroupImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "PrivilegeGroupImpl[" +
      "roles=" +
      this.roles +
      "members=" +
      this.members +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
